import BaseViewModel from "../../Core/BaseViewModel";
import CustomerOrderModel from "../../Models/CustomerOrderModel";


export default class CustomerOrderListViewModel extends  BaseViewModel{
    orders:CustomerOrderModel[]=[];
    total_pages:number=0;
	current_page: number=1;
	loading: boolean = false;
}